/** @format */

// This is code generated automatically by the proto2api, please do not modify

import { webapi } from "$/utils/webapi";
import {
  type CheckInInfo,
  type Guest,
  type Sex,
  type Document,
} from "./checkin_type";

export namespace CheckInService {
  // 获取信息
  export function Get(req: GetReq, config?: any) {
    return webapi.post<GetResp>("/api/v1/CheckInService_Get", req, config);
  }

  // 在线登记
  export function Submit(req: SubmitReq, config?: any) {
    return webapi.post<SubmitResp>(
      "/api/v1/CheckInService_Submit",
      req,
      config,
    );
  }

  // 获取image资源token 用于上传图片
  export function GenImageToken(req: GenImageTokenReq, config?: any) {
    return webapi.post<GenImageTokenResp>(
      "/api/v1/CheckInService_GenImageToken",
      req,
      config,
    );
  }

  // 证件识别
  export function RecognizeDocument(req: RecognizeDocumentReq, config?: any) {
    return webapi.post<RecognizeDocumentResp>(
      "/api/v1/CheckInService_RecognizeDocument",
      req,
      config,
    );
  }

  // 校验年龄是否满18周岁
  export function VerifyAge(req: VerifyAgeReq, config?: any) {
    return webapi.post<VerifyAgeResp>(
      "/api/v1/CheckInService_VerifyAge",
      req,
      config,
    );
  }
}
// GetReq
export interface GetReq {
  signedOrderId: string;
}

export interface GetResp {
  info: CheckInInfo;
}

// Submit
export interface SubmitReq {
  signedOrderId: string;
  // 房客信息
  guests: Guest[];
}

export interface SubmitResp {}

export interface GenImageTokenReq {
  signedOrderId: string;
}

export interface GenImageTokenResp {
  token: string;
}

// RecognizeDocument
export interface RecognizeDocumentReq {
  signedOrderId: string;
  // 图片id
  imgId: string;
}

// This the module of RecognizeDocumentResp
export namespace RecognizeDocumentResp {
  export interface RecognizeResult {
    // 姓
    familyName: string;
    // 名
    givenName: string;
    // 生日 xxxx年xx月xx日
    birthday: string;
    // 性别
    sex: Sex;
    // 国籍
    nationality: string;
    // 证件号码
    document: Document;
  }
}
export interface RecognizeDocumentResp {
  // 没有识别出结果，返回空结构体
  result: RecognizeDocumentResp.RecognizeResult;
}

// VerifyAge 校验年龄是否满18周岁
export interface VerifyAgeReq {
  signedOrderId: string;
  // 生日，格式：yyyy-MM-dd
  birthday: string;
}

export interface VerifyAgeResp {
  // 是否满18周岁 @bool
  isAdult: boolean;
}
